<template>
  <div style="width: 1200px; margin: 0 auto; paddingTop: 24px;">
    <template v-if="groupingShow">
      <!-- 1.1 数据更新时间 -->
      <div class="systemDesc">
        <span class="update">数据更新时间：{{ this.currentdate }}</span>
        <span style="float: right; margin-right: 20px" class="switch-btn">
          <!-- 1.2 人群获取按钮-->
          <el-switch
            v-model="isOpenFlag"
            @change="changeSwitch(isOpenFlag)"
            class="switch"
            active-color="#6461E7"
          ></el-switch>
          <span>人群获取</span>
          <el-tooltip :content="iconConent" placement="top" effect="light">
            <img
              src="../../assets/images/crowd/question.png"
              alt
              style="width: 14px; height:14px; position: relative; top: 2px;"
            >
          </el-tooltip>
        </span>
      </div>

      <!-- 2.1 行业人群标题 -->
      <template v-for="(item, index) in officialListitem">
        <div class="classifyName systems" :key="index + '@'" v-if="isOpenFlag">
          <div>
            <span
              style="line-height:25px; fontWeight: bold; color: #333333; fontSize: 18px; fontFamily: PingFang SC-Bold, PingFang SC; "
            >{{ item.classifyName }}</span>
          </div>
          <div style="marginTop: 8px; display: flex; justifyContent: space-between;">
            <div>
              <span
                style="padding-left: 4px;fontSize: 14px;color:#999999;line-height:20px"
              >{{ item.classifyDescription }}</span>
            </div>

            <!-- 2.2 展开&收起 -->
            <div>
              <span
                class="open"
                @click="handleOpenSystem(index)"
                v-show="item.list&&item.list.length >= 4"
              >
                {{ item.openSystem? "展开全部" : "收起全部" }}
                <i
                  :class="item.openSystem? 'el-icon-arrow-down': 'el-icon-arrow-up'"
                ></i>
              </span>
            </div>
          </div>
        </div>

        <!-- 3.行业人群列表 -->
        <div style="width: 1200px; marginTop: 6px;" :key="index + '?'" v-if="isOpenFlag">
          <el-row :gutter="20">
            <el-col
              v-for="info in item.list"
              :span="8"
              :key="info.precisionCrowdStrategyId"
              class="row-bg"
            >
              <template v-if="info.isHide">
                <div class="tempList" style="margin:10px 0; position: relative;">
                  <img v-if="info.iconPath" :src="info.iconPath" class="imgpath">
                  <div class="item-box">
                    <div class="headName">
                      <img class="i" src="../../assets/images/crowd.png" alt>
                      <span class="name">{{ info.name }}</span>
                      <div class="wrap-name">
                        <!-- hot标志 -->
                        <img v-if="info.logoType === 1" src="@/assets/images/HOT.svg" alt>
                        <!-- new标志 -->
                        <img v-if="info.logoType === 2" src="@/assets/images/new.svg" alt>
                      </div>
                    </div>
                    <div class="desc">
                      <el-popover
                        v-if="info.description.length > 15"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="info.description"
                      >
                        <div slot="reference" class="reference">{{ info.description }}</div>
                      </el-popover>
                      <div v-else class="reference">{{ info.description }}</div>
                    </div>
                    <div class="footBtn" v-if="!info.isAdvanced">
                      <p>{{ info.count }}人</p>
                      <div class="btns">
                        <el-button
                          class="anaysis_button1"
                          style="cursor:pointer"
                          v-if="(info.type == 0 || info.type == 1) && info.count != 0"
                          @click="handleAnalysis(info)"
                        >人群分析</el-button>
                        <!-- <el-button class="anaysis_button1" style="cursor:pointer">人群分析</el-button> -->
                        <el-button
                          class="yinxiao_button1"
                          style="cursor:pointer"
                          v-zoom="{ from: pageName, name: '立即营销' }"
                          v-show="item.count != 0"
                          @click="goToMarketing(item)"
                        >立即营销</el-button>
                      </div>
                    </div>
                    <div v-if="info.isAdvanced" style="display:flex; justifyContent:space-between">
                      <div class="upBtn">
                        <img
                          src="../../assets/images/crowd/highIcon.png"
                          alt
                          style="position: relative;top: 2px;"
                        >
                        <span
                          style="display: inline-block; color:#C65300; marginLeft: 2px; fontSize: 14px;"
                        >高级版专属</span>
                      </div>
                      <div>
                        <span class="upgrade" @click="upgrade(item)">点击升级</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-col>
          </el-row>
        </div>
      </template>
    </template>

    <!-- 4.提示（人群获取按钮关闭） -->
    <div v-if="!isOpenFlag" style="padding:100px;text-align:center">
      <div>
        <img
          style="width:300px;height:300px; marginBottom:30px; "
          src="../../assets/images/人群获取关闭.svg"
        >
      </div>
      <span style="color:#666666;font-size: 14px;">行业人群获取已关闭，如需获取请手动开启；</span>
    </div>

    <!-- 5.人群分析按钮 -->
    <analysis
      v-if="analysisIsShow"
      @back="analysisBack"
      :sellerList="sellerList"
      :show="analysisIsShow"
      :crowdArray="crowdArray"
    ></analysis>
    <!-- <jd-navigator></jd-navigator> -->
  </div>
</template>

<script>
import { getSellerInfo } from "@/api/sellerController";
import {
  getOfficialmemberCrowd,
  updateIsGetCrowd
} from "@/api/manage/memberCrowdController";
import analysis from "./components/analysis";
// import jdNavigator from "./components/jd-navigator";
import { getSellercats } from "@/api/analysis/ware-controller";
import { getClickData } from "../../api/yusms/industryBreakCircle.js";
export default {
  name: "industryCrowd",
  components: {
    analysis,
    // jdNavigator
  },
  props: {},
  data() {
    return {
      // 定制开关
      isOpenFlag: true,
      // 获取当前时间
      currentdate: "",
      // 展开&收起
      openSystem: "false",
      // 列表数据
      list: "",
      // loadingTable: true,
      // 行业开关
      isOpenFlagOne: "",
      // 定制开关
      isOpenFlagOne: "",
      officialListitem: [],
      shopMemberType: "",
      // 查询系统会员人群
      sysTypeLink: "",
      // 升级按钮
      jumpUrl: "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=myarticle",
      // 营销按钮
      pageName: "客户营销-客户分群",
      // 人群分析状态控制
      analysisIsShow: false,
      sellerList: [],
      // 人群分析状态控制
      analysisIsShow: false,
      crowdArray: {},
      // 首屏显示隐藏控制
      groupingShow: true,
      // loading加载
      loading: true
    };
  },
  computed: {
    // 1.人群提示
    iconConent() {
      // 人群提示
      let content = "";
      content = "行业人群占用商家自定义创建人群个数，如已关闭可手动开启；";
      return content;
    }
  },
  created() {
    getSellercats().then(res => {
      this.sellerList = res.data;
    });
    getSellerInfo().then(resp => {
      // 获取行业人群列表
      this.getSystemList1(resp.data.isIndustryGet);
    });
  },
  mounted() {
    // 获取当前时间
    this.dateFormat();
    // 埋点
    this.buriedPoint(1, "行业人群", "行业专区", "行业人群");
  },
  methods: {
    // 1.获取当前时间
    dateFormat() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      this.currentdate = currentdate;
    },
    // 2.行业开关
    changeSwitch(val) {
      this.isOpenFlag = val;
      let obj = {
        type: 1,
        // 0关闭 1开启
        isOpen: val ? 1 : 0
      };
      localStorage.setItem("crowd", JSON.stringify(obj.isOpen));
      this.updateIsGetCrowd(obj);
    },
    // 3. 开关
    updateIsGetCrowd(obj) {
      this.officialListitem = [];
      updateIsGetCrowd(obj).then(res => {
        if (res.code == 1) {
          this.$message.success("执行成功!");
          this.getSystemList1(obj.isOpen);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 4.获取系统人群
    getSystemList1(val) {
      const params = { sysType: val };
      this.isOpenFlag = val ? true : false;
      this.officialListitem = [];
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "LoadingSass"
      });
      getOfficialmemberCrowd(params).then(res => {
        if (res.data && res.code == 1) {
          this.systemData = res.data.length ? res.data[0].list : [];
          this.systemDataName = res.data.length ? res.data[0].classifyName : [];
          this.systemDataDescription = res.data.length
            ? res.data[0].classifyDescription
            : [];
          this.officialListitem = res.data;
          var shopMemberType = this.shopMemberType;
          //查看更多根据类型跳转到对应的页面
          this.sysTypeLink = res.data.length ? res.data[0].type : [];
          if (this.officialListitem && this.officialListitem.length > 0) {
            this.officialListitem.forEach((item, i) => {
              item.isHide = i <= 2 ? true : false;
            });
          }
          this.officialListitem.forEach(item => {
            item.openSystem = true;
            item.list.forEach((info, i) => {
              if (i <= 2) {
                info.isHide = true;
              } else {
                info.isHide = false;
              }
            });
          });
        }
        loading.close();
      });
    },
    // 5.展开&收起
    handleOpenSystem(index) {
      this.officialListitem = this.officialListitem.map((item, num) => {
        let obj = item;
        if (num === index) {
          obj.openSystem = !item.openSystem;
          obj.list.forEach((info, i) => {
            if (!item.openSystem) {
              info.isHide = true;
            } else {
              info.isHide = i <= 2 ? true : false;
            }
          });
        }
        return obj;
      });
    },
    // 6.升级按钮（高级版本立即升级）
    upgrade(item) {
      window.open(this.jumpUrl, "_blank");
    },
    // 7.点击人群分析按钮
    handleAnalysis(value) {
      this.groupingShow = false;
      this.analysisIsShow = true;
      this.show = true;
      this.crowdArray = value;
    },
    // 8.点击立即营销按钮
    goToMarketing(item) {
      window.localStorage.setItem("strategy", JSON.stringify(item));
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/accurate_market",
        query: { to: "grouping" }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 9.人群分析隐藏
    analysisBack() {
      this.analysisIsShow = false;
      this.groupingShow = true;
    }
  }
};
</script>
<style lang="scss">
//修改Loading样式
.LoadingSass {
  .el-loading-spinner i {
    color: #ffffff !important;
    font-size: 20px;
  }
  .el-loading-spinner .el-loading-text {
    color: #ffffff !important;
    padding: 10px 0;
    font-size: 16px;
  }
}
</style>

<style lang='scss' scoped>
/deep/.row-bg {
  background-color: transparent !important;
}

.systemDesc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  .update {
    margin-left: 8px;
  }

  .switch-btn {
    span {
      display: inline-block;
      margin: 0 4px 0 3px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
  }

  .system {
    display: inline-block;
  }
}

.classifyName {
  display: block;
  position: relative;
  font-size: 14px;
  padding: 10px 10px 0 13px;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  color: #333;
  min-height: 40px;

  &::after {
    content: "";
    position: absolute;
    left: 5px;
    display: block;
    background: #6461e7;
    height: 18px;
    width: 4px;
    border-radius: 2px;
    top: 13px;
  }

  .open {
    color: #999999;
    font-size: 14px;
    cursor: pointer;
  }
}

.tempList {
  width: 386px;
  height: 212px;
  position: relative;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #f5f3ff;
  margin-right: 20px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;

  .refer {
    width: 80px;
    height: 24px;
    position: absolute;
    right: 0;
    background: linear-gradient(135deg, #fe8845 0%, #fe4d45 100%);
    border-radius: 0px 12px 0px 12px;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    text-align: center;
  }

  .item-box {
    height: 152px;
    width: 326px;
    margin: 30px 30px 30px 30px;

    .headName {
      display: flex;
      align-items: center;

      .i {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        border-radius: 50%;
        opacity: 1;
        background: rgba(100, 97, 231, 0.1);
      }

      .name {
        color: #333;
        font-size: 16px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .wrap-name {
        img {
          width: 32px;
          height: 16px;
          position: relative;
          top: -13px;
          font-size: 12px;
          left: 4px;
        }
      }
    }

    .desc {
      height: 64px;
      width: 326px;
      margin-top: 16px;
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      line-height: 40px;

      .reference {
        width: 326px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
      }
    }

    .footBtn {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      p {
        color: #6461e7;
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 4px;
        font-weight: 500;
        line-height: 24px;
      }

      .btns {
        text-align: center;

        .anaysis_button1 {
          width: 98px;
          height: 32px;
          color: #85819a;
          border: 1px solid #d8d7e1;
          background-color: #fff;
          border-radius: 19px 19px 19px 19px;
          line-height: 32px;
        }

        .anaysis_button1:hover {
          border-color: #6461e7 !important;
          color: #6461e7;
          background-color: #ffffff;
        }

        .yinxiao_button1 {
          width: 98px;
          height: 32px;
          color: #6461e7;
          border: 1px solid #6461e7;
          background-color: #fff;
          border-radius: 19px 19px 19px 19px;
          line-height: 32px;
        }

        .yinxiao_button1:hover {
          border-color: #6461e7 !important;
          color: #ffffff;
          background: #6461e7;
        }
      }
    }
  }
}

.upBtn {
  height: 32px;
  line-height: 32px;

  img {
    width: 16px;
    height: 16px;
    position: relative;
    top: 3px;
  }
}

.upgrade {
  display: inline-block;
  width: 98px;
  height: 32px;
  background: #ffffff;
  border-radius: 19px 19px 19px 19px;
  opacity: 1;
  border: 1px solid #6461e7;
  cursor: pointer;
  text-align: center;
  line-height: 32px;
  color: #6461e7;
  font-weight: 400;
  font-size: 14px;
}

.upgrade:hover {
  background: #6461e7;
  color: #fff;
}

.tempList:hover,
.tempList:focus {
  -webkit-box-shadow: 0px 0px 30px 0px rgba(100, 97, 231, 0.15);
  box-shadow: 0px 0px 30px 0px rgba(100, 97, 231, 0.15);
  -webkit-transform: translate(0, -12px);
  transform: translate(0, -12px);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.row-bg {
  background-color: #f9fafc;
}

.imgpath {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 33px;
  height: 33px;
  z-index: 1;
}
</style>
